import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import SMORoomExceptionCalendarBaloon from './SMORoomExceptionCalendarBaloon';
import SMConst from 'lib/SMConst';
import SMCalendarHelper from 'components/helpers/SMCalendarHelper';
import SMPlanHelper from 'components/helpers/SMPlanHelper';
import SMRoomExceptionHelper from 'components/helpers/SMRoomExceptionHelper';

class SMORoomExceptionCalendarCell extends React.Component {
  
  cellDidClick(e) {
    e.preventDefault();
    let baloon = <SMORoomExceptionCalendarBaloon
      selectedDate={SMCalendarHelper.cellItemToDate(this.props.item)}
      selectedCalendar={this.props.selectedCalendar}
      clientX={e.clientX}
      clientY={e.clientY}
      room={this.props.room}
      plan={this.props.plan}
      delegate={this.props.delegate} 
    />;
    
    ReactDOM.render(baloon, document.getElementById('js-baloon-container'));
  }
  
  itemDidClick(exception, e){
    e.stopPropagation();
    let baloon = <SMORoomExceptionCalendarBaloon
      item={exception}
      selectedDate={SMCalendarHelper.cellItemToDate(this.props.item)}
      selectedCalendar={this.props.selectedCalendar}
      clientX={e.clientX}
      clientY={e.clientY}
      room={this.props.room}
      plan={this.props.plan}
      delegate={this.props.delegate} 
    />;
    
    ReactDOM.render(baloon, document.getElementById('js-baloon-container'));
  }
  
  renderDefaultPriceText(priceText) {
    return <p className="dashboard-calendar__content-paragraph is-normal">{priceText}</p>;
  }
  
  renderExceptionPriceText(exception, label) {
    return(
      <p key={"room_exception-"+exception.id}
        className="dashboard-calendar__content-paragraph is-changed"
        onClick={this.itemDidClick.bind(this, exception)}>
        {label}
      </p>
    );
  }
  
  renderInnerHtml(item) {
    let latestException = null;
    let exceptionsList = [];
    let regularDailyPriceText = SMPlanHelper.regularDailyPriceText(this.props.plan);
    let regularHourlyPriceText = SMPlanHelper.regularHourlyPriceText(this.props.plan);
    let regularStayPriceText = SMPlanHelper.regularStayPriceText(this.props.plan);

    let regularPriceText = regularHourlyPriceText;
    if (this.props.selectedCalendar == SMConst.CalendarType.StayPrice) {
      regularPriceText = regularStayPriceText;
    } else if (this.props.selectedCalendar == SMConst.CalendarType.DailyPrice) {
      regularPriceText = regularDailyPriceText;
    }
    
    if (item.status == SMConst.RoomStatus.Close) {
      return <p className="dashboard-calendar__content-paragraph">利用不可</p>;
    } else if (item.exceptions.length == 0) {
      return this.renderDefaultPriceText(regularPriceText);
    } else {
      if (this.props.selectedCalendar == SMConst.CalendarType.DailyPrice || this.props.selectedCalendar == SMConst.CalendarType.StayPrice) {
        for (let i=0; i < item.exceptions.length; i++) {
          let exception = item.exceptions[i];
          if (SMRoomExceptionHelper.isDailyPrice(exception, this.props.plan) || SMRoomExceptionHelper.isStayPrice(exception, this.props.plan)) {
            if (latestException == null || Date.parse(exception.updated_at) > Date.parse(latestException.updated_at)) {
              latestException = exception;
            }
          }
        }

        if (latestException == null) return this.renderDefaultPriceText(regularDailyPriceText);
        if (this.props.selectedCalendar == SMConst.CalendarType.DailyPrice) return this.renderExceptionPriceText(latestException, SMRoomExceptionHelper.exceptionDailyPriceText(latestException));
        if (this.props.selectedCalendar == SMConst.CalendarType.StayPrice) return this.renderExceptionPriceText(latestException, SMRoomExceptionHelper.exceptionStayPriceText(latestException));
      } else {
        for (let i=0; i < item.exceptions.length; i++) {
          let exception = item.exceptions[i];
          if (SMRoomExceptionHelper.isHourlyPrice(exception, this.props.plan)) {
            exceptionsList.push(
              <p key={"room_exception-"+exception.id}
                className="dashboard-calendar__content-paragraph is-changed" 
                onClick={this.itemDidClick.bind(this, exception)}>
                <span className="dashboard-calendar__content-time">{SMRoomExceptionHelper.exceptionHoursText(exception)}</span>
                <span className="dashboard-calendar__content-value">{SMRoomExceptionHelper.exceptionHourlyPriceText(exception)}</span>
              </p>
            );
          }
        }

        return exceptionsList.length == 0 ? this.renderDefaultPriceText(regularHourlyPriceText) : exceptionsList; 
      }
    }
  }
  
  render() {
    if (SMCalendarHelper.isPast(this.props.item, this.props.today)) {
      return(
        <td className={SMCalendarHelper.cellClassName(this.props.item, this.props.year, this.props.month, this.props.today)}>
          <div className="dashboard-calendar__cell-wrap">
             <p className="dashboard-calendar__date">{this.props.item.day}</p>
             <div className="dashboard-calendar__content"></div>
          </div>
        </td>
      );
    } else {
      return(
        <td className={SMCalendarHelper.cellClassName(this.props.item, this.props.year, this.props.month, this.props.today)}>
          <a href="#" className="dashboard-calendar__cell-wrap" 
            onClick={SMCalendarHelper.isClosed(this.props.item) ? null : this.cellDidClick.bind(this)}>
            <p className="dashboard-calendar__date">{this.props.item.day}</p>
            <div className="dashboard-calendar__content">
              {this.renderInnerHtml(this.props.item)}
            </div>
          </a>
        </td>
      );
    }
  }
}

SMORoomExceptionCalendarCell.propTypes = {
  item: PropTypes.object.isRequired,
  today: PropTypes.instanceOf(Date).isRequired,
  room: PropTypes.object.isRequired,
  plan: PropTypes.object.isRequired,
  delegate: PropTypes.object,
  selectedCalendar: PropTypes.number,
};

export default SMORoomExceptionCalendarCell;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/calendar/SMORoomExceptionCalendarCell.jsx